import * as a from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Database.es.js";
const e = a.forwardRef((o, t) => /* @__PURE__ */ a.createElement(r, { ref: t, ...o, weights: s }));
e.displayName = "DatabaseIcon";
const n = e;
export {
  n as Database,
  e as DatabaseIcon
};
